import { shallowReadonly, shallowRef, type Component, type ShallowRef } from 'vue'

type PromiseDialogState = {
  id: number
  component: Component
  props: Record<string, unknown>
  resolve: (value: unknown) => void
}

const activeDialog: ShallowRef<PromiseDialogState | null> = shallowRef(null)
let nextDialogId = 0

export const openDialog = <TResult = unknown>(
  component: Component,
  props: Record<string, unknown>,
): Promise<TResult> =>
  new Promise<TResult>((resolve) => {
    activeDialog.value = {
      id: ++nextDialogId,
      component,
      props,
      resolve: (value) => resolve(value as TResult),
    }
  })

export const closeDialog = (value: unknown) => {
  const dialog = activeDialog.value
  if (!dialog) return

  activeDialog.value = null
  dialog.resolve(value)
}

export const usePromiseDialogState = () => shallowReadonly(activeDialog)
